export const clearAuthSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("user_name");
    sessionStorage.removeItem("user_email");
    sessionStorage.removeItem("user_role");
};

const decodeJwtPayload = (token) => {
    try {
        const payload = token.split(".")[1];
        if (!payload) return null;

        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");

        return JSON.parse(atob(padded));
    } catch {
        return null;
    }
};

//just checks expiry date of token. signature validation done on backend
export const isTokenExpired = (token) => {
    const payload = decodeJwtPayload(token);

    if (!payload?.exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
};

export const hasRole = (...roles) => {
    return roles.includes(sessionStorage.getItem("user_role"));
};

export const isManager = () => hasRole("SUPER_ADMIN", "ADMIN", "MANAGER");
export const isDistributor = () => hasRole("DISTRIBUTOR")
export const isAdmin = () => hasRole("SUPER_ADMIN", "ADMIN");